// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-logo-img[data-v-6c406378]{max-width:140px;width:auto;height:auto;max-height:40px;-o-object-fit:contain;object-fit:contain}@media (max-width:991.98px){.header-logo-img[data-v-6c406378]{max-width:110px;max-height:36px}}@media (max-width:575.98px){.header-logo-img[data-v-6c406378]{max-width:96px;max-height:32px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
